import {
  SCHEDULE_TYPE_MANUAL,
  SCHEDULE_TYPE_SELF,
  SCHEDULE_TYPE_BULK_SELF_SCHEDULE,
} from '@/components/shared/interview-scheduler/constant';

// Whether the fetch that populates the current schedule step is still in flight (ENG-3602 / SCH-798).
export const isSchedulerFetchPending = (
  scheduleType: string,
  isFetching: boolean,
  isScheduleFetching: boolean
): boolean => {
  if (scheduleType === SCHEDULE_TYPE_MANUAL) {
    return isFetching;
  }
  if (
    scheduleType === SCHEDULE_TYPE_SELF ||
    scheduleType === SCHEDULE_TYPE_BULK_SELF_SCHEDULE
  ) {
    return isScheduleFetching;
  }
  return false;
};
